import { Autocomplete, TextField } from '@mui/material';
import { useResponsive } from '@shared';
import { RouteEnum, generateRoutePath } from 'App';
import { useNavigate } from 'react-router-dom';

type TypeProps = {
  value: { label: string; id: string };
  partners?: { label: string; id: string }[];
};

export const MultiplePartnersSelector = ({ value, partners = [] }: TypeProps) => {
  const isMobile = useResponsive({ query: 'down', key: 924 });
  const navigate = useNavigate();

  const goTo = (value?: string) =>
    navigate(
      generateRoutePath({
        name: RouteEnum.Courses,
        params: { partner: value },
      })
    );

  return (
    <Autocomplete
      id='multiple-partners-autocomplete'
      value={value}
      placeholder='Partner'
      size='small'
      sx={{ width: isMobile ? 120 : 250, backgroundColor: 'white' }}
      options={partners}
      renderInput={(params) => <TextField {...params} label='Partner' />}
      onChange={(_, value) => goTo(value?.id)}
    />
  );
};
